import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=30a6af13&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "./upload.vue?vue&type=style&index=0&id=30a6af13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6af13",
  null
  
)

export default component.exports